import a from "./_castPath.js";
import i from "./_toKey.js";
var l = a, f = i;
function s(e, r) {
  r = l(r, e);
  for (var n = 0, t = r.length; e != null && n < t; )
    e = e[f(r[n++])];
  return n && n == t ? e : void 0;
}
var m = s;
export {
  m as default
};
//# sourceMappingURL=_baseGet.js.map
